import { useEffect } from "react";

const BRAND = "British Supplements";
const DEFAULT_DESC = "Premium UK-made supplements for men, women and over 40s. Clean ingredients, honest formulas, Subscribe & Save.";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (data) => {
  document.getElementById("seo-jsonld")?.remove();
  if (!data) return;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = "seo-jsonld";
  s.textContent = JSON.stringify(data);
  document.head.appendChild(s);
};

export const absUrl = (path) => (path?.startsWith("http") ? path : `${window.location.origin}${path || ""}`);

export const useSeo = ({ title, description, image, jsonLd, noindex = false }) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} | Clean UK Supplements`;
    const desc = (description || DEFAULT_DESC).replace(/\s+/g, " ").trim().slice(0, 158);
    const url = absUrl(window.location.pathname);
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", absUrl(image || "/logo512.png"));
    setCanonical(url);
    setJsonLd(ld ? JSON.parse(ld) : null);
  }, [title, description, image, ld, noindex]);
};

export const productJsonLd = (p) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: p.name,
  description: p.description,
  image: [absUrl(p.image)],
  sku: p.id,
  brand: { "@type": "Brand", name: BRAND },
  offers: {
    "@type": "Offer",
    url: absUrl(`/product/${p.slug}`),
    priceCurrency: "GBP",
    price: Number(p.price).toFixed(2),
    availability: p.stock === 0 ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
    itemCondition: "https://schema.org/NewCondition",
  },
  ...(p.rating && p.reviews
    ? { aggregateRating: { "@type": "AggregateRating", ratingValue: p.rating, reviewCount: p.reviews } }
    : {}),
});
